import { render, staticRenderFns } from "./OceanoDessertSection.vue?vue&type=template&id=54d3d107&scoped=true"
import script from "./OceanoDessertSection.vue?vue&type=script&lang=ts"
export * from "./OceanoDessertSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoDessertSection.vue?vue&type=style&index=0&id=54d3d107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3d107",
  null
  
)

export default component.exports